var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="swiper-slide overlay-slider__slide"> <div class="overlay-slider__wrap"> <figure class="overlay-slider__img-container"> <img sizes="(min-width: ';
 print(maxImageWidth + 60) 
__p+='px) '+
((__t=( maxImageWidth ))==null?'':__t)+
'px,\n						(min-width: 576px) calc(100vw - 60px),\n						calc(100vw - 40px)" srcset="'+
((__t=( srcSet ))==null?'':__t)+
'" class="overlay-slider__img" alt="'+
((__t=( imgAlt ))==null?'':__t)+
'"> ';
 if (figCaption || figDescription || figCopyright) {
				print('<figcaption class="overlay-slider__caption">');
				if (figCaption) {
					print(figCaption);
				}
				if (figDescription) {
					print(' ' + figDescription);
				}
				if (figCopyright) {
					print(' &copy; ' + figCopyright);
				}
				print('</figcaption>');
			}
			
__p+=' </figure> </div> </div>';
}
return __p;
};
